















































import Vue, { PropType } from 'vue';
import { createNamespacedHelpers } from 'vuex';
import * as CvPreviewStore from '@/store/modules/cvPreview';
// @ts-ignore
import CvPreview, {
  PageBreakPayload,
} from '@/components/section-preview/CvPreview.vue';
import { debounce } from 'vue-debounce';
import { CvCvSectionWithSection } from '@/containers/cv/store';
import { makeSectionsMap } from '@/pages/cvs/_cvId/preview/-utils';
import { SectionsMapType } from '@/pages/cvs/_cvId/preview/-types';
import { RESIZE_LISTENERS, SP_WIDTH } from 'src/utils/constants';
import { Cv, CvDesignTemplate, CvSectionProfile } from 'gen';

const { mapGetters } = createNamespacedHelpers(CvPreviewStore.namespace);

export default Vue.extend({
  components: {
    CvPreview,
  },
  props: {
    cv: {
      type: Object as PropType<Cv>,
      required: true,
    },
    cvSections: {
      type: Array as PropType<CvCvSectionWithSection[]>,
      required: true,
    },
    cvSectionProfile: {
      type: Object as PropType<CvSectionProfile>,
      required: true,
    },
    cvDesignTemplate: {
      type: Object as PropType<CvDesignTemplate>,
      required: true,
    },
    isPageBreakMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      cvHeight: null,
      cvOpacity: null,
      cvScale: null,
      windowInnerWidth: window.innerWidth,
    };
  },
  computed: {
    cvId(): string {
      return this.cv?.id;
    },
    previewClasses(): string {
      return `cv-design-template-${this.cvDesignTemplate.name}`;
    },
    sectionsMap(): SectionsMapType {
      return makeSectionsMap(
        this.cvSectionProfile,
        this.cvSections,
        this.cvDesignTemplate.name
      );
    },
    isSpWidth(): boolean {
      return this.windowInnerWidth < SP_WIDTH;
    },
  },
  mounted() {
    this.adjustCvPreviewSize();
    this.initCvPreview();
    this.cvWrapperHeight = this.$refs.CvPreviewPageWrapper.clientHeight;
  },
  destroyed() {
    this.clearCvPreview();
  },
  methods: {
    initCvPreview() {
      RESIZE_LISTENERS.forEach(type =>
        window.addEventListener(type, this.adjustCvPreviewSize, false)
      );
    },
    clearCvPreview() {
      RESIZE_LISTENERS.forEach(type =>
        window.removeEventListener(type, this.adjustCvPreviewSize, false)
      );
    },
    adjustCvPreviewSize: debounce(function() {
      this.windowInnerWidth = window.innerWidth;

      if (this.isSpWidth) {
        const cvWrapperWidth = this.$refs.CvPreviewPageWrapper?.clientWidth;
        const cvBodyWidth = this.$refs.CvPreviewPageWrapperInner?.clientWidth;
        if (!cvWrapperWidth || !cvBodyWidth) return;

        const cvWrapperRatio = cvWrapperWidth / cvBodyWidth;
        const cvWrapperHeightSp = this.cvWrapperHeight * cvWrapperRatio;
        this.cvHeight = Math.round(cvWrapperHeightSp) + 'px';
        this.cvScale = cvWrapperRatio;
        this.cvOpacity = '1.0';
      } else {
        this.cvHeight = '100%';
        this.cvScale = '1.0';
        this.cvOpacity = '1.0';
      }
    }, '200ms'),
    onSubmitPageBreak(payload: PageBreakPayload) {
      this.$emit('submit-page-break', payload);
    },
  },
});
